<div class="bakgrunn-og-tittel">
  <div class="bakgrunn-tittel">{{bakgrunn()?.tittel()}}</div>
  <div class="bakgrunn">
    <ng-content select="[bakgrunn]"/>
  </div>
</div>
<div class="handlinger-og-informasjon">
  <!-- én eller flere handlinger -->
  <ng-content select="[handling]"/>
  <!-- data-informasjonelement brukes for å identifisere klikk fra dette elementet eller dets barn -->
  <div class="informasjon" data-informasjonelement="true">
    <ng-content select="[filnavn]"/>
    <ng-content select="[metainformasjon]"/>
  </div>
</div>
